import { useMemo } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { i18n } from '@lingui/core';

const useDataGrid = () => {
  const columns = useMemo(
    () => [
      {
        field: 'siteName',
        flex: 0.8,
        headerName: i18n._('safeSend.tabs.header.dbName'),
      },
      {
        field: 'nbBlackListedEmails',
        flex: 0.8,
        headerName: i18n._('safeSend.tabs.header.emails'),
        renderCell: (params: GridRenderCellParams<number>) =>
          params.value?.toLocaleString('FR-fr'),
      },
      {
        field: 'nbSuspiciousActions',
        flex: 0.8,
        headerName: i18n._('safeSend.tabs.header.actions'),
        renderCell: (params: GridRenderCellParams<number>) =>
          params.value?.toLocaleString('FR-fr'),
      },
      {
        field: 'currentSubState',
        flex: 0.8,
        headerName: i18n._('safeSend.tabs.header.status'),
      },
    ],
    []
  );

  return {
    columns,
  };
};

export default useDataGrid;
